import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Area } from "../models/Area";
import { useAuth } from "../context/AuthContext";
import { colors, fonts, radius } from "../utils/colors";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const logo = process.env.PUBLIC_URL + "/logoXenit.png";

interface AreasNavProps {
  areas: Area[];
  ratings: Record<string, number>;
  isAreaComplete: (area: Area, ratings: Record<string, number>) => boolean;
  isLoggedIn: boolean;
  noActivePeriod: boolean;
}

const AreasNav: React.FC<AreasNavProps> = ({
  areas,
  ratings,
  isAreaComplete,
  isLoggedIn,
  noActivePeriod
}) => {
  const location = useLocation();
  const { isAdmin } = useAuth();

  return (
    <nav
      style={{
        marginBottom: "30px",
        display: "flex",
        alignItems: "center",
        backgroundColor: colors.darkBlue,
        padding: "10px 16px",
        fontFamily: fonts.main,
        position: "sticky",
        top: 0,
        zIndex: 1100,
      }}
    >
      <div style={{ marginRight: "0px", display: "flex", alignItems: "center" }}>
        <Link
          to="/"
          style={{
            margin: "0 20px",
            textDecoration: "none",
            color: location.pathname === "/" ? colors.green : colors.white,
            fontWeight: 600,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            transition: "color 0.2s ease",
          }}
        >
          <img
            src={logo}
            alt="Xenit"
            style={{ height: "42px", width: "42px", objectFit: "contain" }}
          />
          <span style={{ marginLeft: "10px" }}>Home</span>
        </Link>
      </div>

      <div style={{ display: "flex", justifyContent: "center", flex: 1 }}>
        {areas.map(area => {
          const isActive = location.pathname === `/areas/${area.areaId}`;
          const baseStyle: React.CSSProperties = {
            margin: "0 20px",
            textDecoration: "none",
            fontWeight: 600,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            color: isActive ? colors.green : colors.white,
            transition: "color 0.2s ease",
          };

            if (noActivePeriod || !isLoggedIn) {
              return (
                <span
                  key={area.areaId}
                  style={{
                    ...baseStyle,
                    color: colors.mediumGray,
                    cursor: "not-allowed",
                    pointerEvents: "none",
                    opacity: 0.6
                  }}
                  title="No active period"
                >
                  {area.areaName}
                  {isAreaComplete && isAreaComplete(area, ratings) && (
                    <CheckCircleIcon sx={{ ml: 1, fontSize: 16, color: colors.green }} />
                  )}
                </span>
              );
            }

          return (
            <Link
              key={area.areaId}
              to={`/areas/${area.areaId}`}
              style={baseStyle}
            >
              {area.areaName}
              {isAreaComplete && isAreaComplete(area, ratings) && (
                <CheckCircleIcon sx={{ ml: 1, fontSize: 16, color: colors.green }} />
              )}
            </Link>
          );
        })}
      </div>  

      {/* Admin Link on the right */}
      {isLoggedIn && isAdmin && (
        <div style={{ marginLeft: "auto", marginRight: "20px" }}>
          <Link
            to="/admin"
            style={{
              textDecoration: "none",
              color: location.pathname === "/admin" ? colors.green : colors.white,
              fontWeight: 600,
              padding: "8px 16px",
              borderRadius: `${radius.md}px`,
              border: location.pathname === "/admin"
                ? `2px solid ${colors.green}`
                : `2px solid ${colors.mediumGray}`,
              transition: "all 0.2s ease",
              fontFamily: fonts.main,
            }}
          >
            Admin
          </Link>
        </div>
      )}
    </nav>
  );
};

export default AreasNav;